import type { TeamDetailed, UpdateTeamRequest } from '@clsplus/api-types/api-admin'

import { requestApiJsonOrThrow } from '../request-handler'

export function updateTeamDetails(teamId: string, formData: UpdateTeamRequest): Promise<TeamDetailed> {
  return requestApiJsonOrThrow<TeamDetailed>(`admin/teams/${teamId}`, {
    method: 'PATCH',
    body: formData,
  })
}
